import { createStore } from "vuex";
import router from "@/router";
function formatRoute(data) {
  const routes = [];
  data.forEach((item) => {
    const route = {
      path: item.Path,
      name: item.Name,
      meta: { icon: "order", title: item.MenuName },
      component:() => import('@/' + item.component)
    }
    if(item.children && item.children.length > 0) {
      routes.push({
        ...route,
        children: formatRoute(item.children)
      })
    }else{
      routes.push(route)
    }
  });
  return routes;
}
export default createStore({
  state: {
    menu:[],
  },
  getters: {},
  mutations: {
    SETMENU(state, menu) {
      state.menu = menu
    },
    ADDROUTES(state) {
      const routes = formatRoute(state.menu)
      routes.forEach(item => router.addRoute(item))
    }
  },
  actions: {},
  modules: {},
});
